module.exports = __webpack_public_path__ + "static/media/Regulador-01.7cac78a9.jpg";